/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placeholders_Searchusers1Inputs */

const en_placeholders_searchusers1 = /** @type {(inputs: Placeholders_Searchusers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search users`)
};

/**
* | output |
* | --- |
* | "Search users" |
*
* @param {Placeholders_Searchusers1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const placeholders_searchusers1 = /** @type {((inputs?: Placeholders_Searchusers1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeholders_Searchusers1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_placeholders_searchusers1(inputs)
});
export { placeholders_searchusers1 as "placeholders_searchUsers" }